export const firebase = {
  apiKey: 'AIzaSyArAZSgfZJcC_KiXv4s_WAUPhJnyA8De8s',
  authDomain: 'findme-283114.firebaseapp.com',
  databaseURL: 'https://findme-283114.firebaseio.com',
  projectId: 'findme-283114',
  storageBucket: 'findme-283114.appspot.com',
  messagingSenderId: '887262890955',
  appId: '1:887262890955:web:154eed02c2dfb4b53fc44e',
  measurementId: 'G-L2CV8CQ5EM'
}

export const rrfConfig = {
  userProfile: 'users',
  useFirestoreForStorageMeta: true,
  useFirestoreForProfile: true, // Store in Firestore instead of Real Time DB
  enableLogging: false,

}

export default { firebase, rrfConfig }
